class AdditionalProducts {
  constructor(element) {
    this.element = element;
    this.initQuantitySelectors();
  }

  initQuantitySelectors() {
    const quantitySelectors = this.element.querySelectorAll('.quantity-selector');

    for (const selector of quantitySelectors) {
      const input = selector.querySelector('.quantity-selector__input');
      const decreaseBtn = selector.querySelector('.quantity-selector__decrease');
      const increaseBtn = selector.querySelector('.quantity-selector__increase');

      if (!input || !decreaseBtn || !increaseBtn) continue;

      decreaseBtn.addEventListener('click', () => {
        const currentValue = parseInt(input.value) || 1;
        if (currentValue > 1) {
          input.value = currentValue - 1;
          this.#updateQuantity(input);
        }
      });

      increaseBtn.addEventListener('click', () => {
        const currentValue = parseInt(input.value) || 1;
        input.value = currentValue + 1;
        this.#updateQuantity(input);
      });

      input.addEventListener('change', () => {
        const value = parseInt(input.value) || 1;
        if (value < 1) {
          input.value = 1;
        }
        this.#updateQuantity(input);
      });

      input.addEventListener('input', () => {
        const value = input.value.replace(/[^0-9]/g, '');
        input.value = value;
      });
    }
  }

  #updateQuantity(input) {
    // Dispatch a custom event that can be listened to by other components
    const event = new CustomEvent('quantity:change', {
      detail: {
        quantity: parseInt(input.value),
        form: input.closest('form')
      },
      bubbles: true
    });

    input.dispatchEvent(event);
  }
}

// Initialize for existing elements on page load
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.additional-products');
  for (const section of sections) {
    if (!section.hasAttribute('data-initialized')) {
      new AdditionalProducts(section);
      section.setAttribute('data-initialized', 'true');
    }
  }
});

// Handle form submission with better UX
document.addEventListener('submit', (event) => {
  const form = event.target;

  if (!form.classList.contains('additional-products__form')) return;

  const submitButton = form.querySelector('.additional-products__add-to-cart');

  if (!submitButton) return;

  // Prevent double submission
  if (submitButton.disabled) {
    event.preventDefault();
    return;
  }

  // Show loading state
  const originalText = submitButton.textContent;
  submitButton.textContent = 'Adding...';
  submitButton.disabled = true;

  // Re-enable button after a short delay in case of errors
  setTimeout(() => {
    submitButton.textContent = originalText;
    submitButton.disabled = false;
  }, 3000);
});
